import * as React from "react"
import { Typography } from '@mui/material';
import Fluid from 'components/Fluid';
import { useStaticQuery, graphql } from 'gatsby';
import useLiveData from 'hooks/useLiveData';
import Link from 'components/Link';
import LongArrowButton from 'components/LongArrowButton';

import { ReactComponent as Facebook } from 'images/icons/facebook.svg';
import { ReactComponent as Instagram } from 'images/icons/instagram.svg';
import { ReactComponent as Twitter } from 'images/icons/twitter.svg';
import { ReactComponent as Youtube } from 'images/icons/youtube.svg';
import { ReactComponent as Pinterest } from 'images/icons/pinterest.svg';

import WCTLogo from 'images/wct_logo.svg';
import KWCBLogo from 'images/kwcb_logo.svg';
import AWLogo from 'images/aw_logo.svg';


const Footer = (props) => {
	const data = useStaticQuery(graphql`
		query {
		  allContentMenu (filter: {menuID: {in: ["footer", "footer_top", "footer_bottom"]}}) {
		    edges {
		      node {
				menuID
		        pages
		      }
		    }
		  }
		}
	`);
	const { response } = useLiveData({
		type: 'ContentMenu',
		method: 'all',
		apiParams: {
			menuID: 'footer,footer_top,footer_bottom',
		},
		staticData: data,
	});
	const topNav = response?.data?.find(item => item.menuID === 'footer_top')?.pages || [];
	const footerNav = response?.data?.find(item => item.menuID === 'footer')?.pages || [];
	const bottomNav = response?.data?.find(item => item.menuID === 'footer_bottom')?.pages || [];

	const year = new Date().getFullYear();

	return (
		<footer>
			<nav className="footer__top">
				<Fluid layout="12">
					<ul>
						{ topNav.map((item) => (item.visible === 'true' || item.visible === true) && <li key={item.id}><Link variant="button" component={LongArrowButton} href={item.href} target={item.target}>{item.text}</Link></li>)}
					</ul>
				</Fluid>
			</nav>
			<div className="footer__main">
				<div className="footer__main__top">
					<Fluid layout="33">
						<div>
							<Typography variant="h5" component="div" className="footer__main__header">Visitor Center</Typography>
							<address>
								<Typography variant="body1">
									25777 US Highway 331 South<br/>
									Santa Rosa Beach, Florida 32459<br/>
									(800) 822-6877 or (850) 267-1216<br/>
								</Typography>
							</address>
						</div>
						<div>
							<div className="footer__main__social">
								<Link href="https://www.facebook.com/visitsouthwalton/?utm_medium=referral&utm_source=visitsouthwalton.com&utm_campaign="><Facebook className="footer__main__social__facebook" alt="South Walton's Facebook page"/></Link>
								<Link href="https://www.instagram.com/southwalton/?utm_medium=referral&utm_source=visitsouthwalton.com&utm_campaign="><Instagram className="footer__main__social__instagram" alt="South Walton's Instagram page"/></Link>
								<Link href="https://twitter.com/SouthWalton?utm_medium=referral&utm_source=visitsouthwalton.com&utm_campaign="><Twitter className="footer__main__social__twitter" alt="South Walton's Twitter page" /></Link>
								<Link href="https://www.youtube.com/channel/UCQkgmhFAMsZ9-0JQbW_0YfQ?utm_medium=referral&utm_source=visitsouthwalton.com&utm_campaign="><Youtube className="footer__main__social__youtube" alt="South Walton's Youtube page" /></Link>
								<Link href="https://www.pinterest.com/southwalton/?utm_medium=referral&utm_source=visitsouthwalton.com&utm_campaign="><Pinterest className="footer__main__social__pinterest" alt="South Walton's Pinterest page" /></Link>
							</div>
							<div className="footer__main__contact"><Link href="/contact/">Contact Us</Link></div>
						</div>
						<nav className="footer__main__links">
							<Typography variant="body1" component="div">
								<ul>
									{ footerNav.map((item) => (item.visible === 'true' || item.visible === true) && <li key={item.id}><Link href={item.href} target={item.target}>{item.text}</Link></li>)}
								</ul>
							</Typography>
						</nav>
					</Fluid>
				</div>
				<div className="footer__main__bottom">
					<Link href="https://www.waltoncountyfltourism.com"><img width="100%" height="100%" className="footer__main__bottom__wctlogo" src={WCTLogo} alt="Walton County FL Tourism" /></Link>
					<Link href="https://www.keepwaltoncountybeautiful.org"><img width="100%" height="100%" className="footer__main__bottom__kwcblogo" src={KWCBLogo} alt="Keep Walton County Beautiful" /></Link>
					<Link href="https://www.authenticwalton.com"><img width="100%" height="100%" className="footer__main__bottom__awlogo" src={AWLogo} alt="Authentic Walton" /></Link>
				</div>
			</div>
			<div className="footer__bottom">
				<Fluid layout="6 6">
					<small><Typography variant="body1">&copy; Copyright {year} Walton County TDC, All rights reserved.</Typography></small>
					<nav className="footer__bottom__links">
						<Typography variant="body1" component="div">
							<ul>
								{ bottomNav.map((item) => (item.visible === 'true' || item.visible === true) && <li key={item.id}><Link href={item.href} target={item.target}>{item.text}</Link></li>)}
							</ul>
						</Typography>
					</nav>
				</Fluid>
				<Fluid layout="100%">
					<Typography variant="legal" component="small">
						This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">Privacy Policy</a> and <a href="https://policies.google.com/terms" target="_blank" rel="noreferrer">Terms of Service</a> apply.
					</Typography>
				</Fluid>
			</div>
		</footer>
	)
}

export default Footer;